module.exports = __webpack_public_path__ + "static/img/1.c8f08856.jpg";